export default __webpack_public_path__ + "static/media/Bankingwebservicesbg.a313da13.svg";